module.exports = __webpack_public_path__ + "img/cpany10.643c36a8.png";